<template>
  <div class="edit-wonderful-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" label-width="100px" >
        <el-form-item label="排序:" prop="">
            <el-input v-model.number="params.number" size="small" placeholder="请输入排序"></el-input>
        </el-form-item>
        <el-form-item label="封面:" prop="">
          <base-upload :cover="params.cover" :action="action" @successCallback="successCallback" :wSize="360" :hSize="480" :width="'180px'" :height="'240px'"></base-upload>
        </el-form-item>
        <el-form-item label="状态:">
          <el-switch v-model="params.isActive"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitForm('form')" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { nowDate} from '@/utils/global'
import baseConfig from '@/utils/serverUrlConfig'
import API from '@/api'
export default {
  data() {
    return {
      id: '',
      flag: false,
      title: '',
      dialogVisible: false,
      // 时间段1选择范围
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      // 时间段2选择范围
      pickerOptions2: {},
      params: {
        number: '',
        related: '',
        startTime: '',
        endTime: '',
        cover: ''
      },
      // 图片上传地址
      action: baseConfig.baseServerUrl + '/vid/uploadStatic',
    }
  },
  
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.type === 'edit') {
            this.editWonderful()
          } 
        } else {
          return false;
        }
      });
    },
    // 编辑精彩
    editWonderful() {
      let params = Object.assign({}, this.params, { id: this.id })
      API.updateWonderful(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
          this.$emit('handlerWonderfulList')
        } else {
          this.$message.error('编辑失败')
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        number: '',
        related: '',
        startTime: '',
        endTime: '',
        cover: ''
      }
    },

    // 开始时间 验证
    getTime1(times) {
      this.params.endTime = ''
      if (times.getTime() < new Date(nowDate()).getTime()) {
        this.$message.error('开始时间不能小于当前时间！');
        this.params.startTime = ''
      }
      this.pickerOptions2 = Object.assign({}, this.pickerOptions2, {
        disabledDate: time => {
          return time.getTime() < times - 8.64e7;
        }
      })
    },
    // 结束时间 验证
    getTime2(times) {
      if (times.getTime() <= new Date(this.params.startTime).getTime()) {
        this.$message.error('结束时间不能小于开始时间！');
        this.params.endTime = ''
      }
    },
    open(type,row) {
      this.dialogVisible = true
      if(type === 'edit') {
        this.title = '编辑精彩'
        window.console.log(row)
      }
      
    },
    // 标签封面上传成功回掉
    successCallback(res) {
      this.params.cover = res.data.coverImg
    },
  }
}
</script>
<style scoped>
  .el-input {
    width: 180px;
  }
</style>